export default __webpack_public_path__ + "static/media/A_wdt_c_cap_1.66dcd1ca.mp3";